import { componentClassName } from '@/styles/Footer';
import { Component, ComponentProps } from '@/types/component';
import mergeProps from 'lib/utils/mergeProps';

export type FooterEditorsProps = ComponentProps<'div'>;

export const FooterEditorsComponent: Component<FooterEditorsProps> = ({
  variant,
  size,
  colors,
  children,
  ...props
}) => {
  const className = componentClassName('editors', { variant, size, colors });

  return <div {...mergeProps({ className }, props)}>{children}</div>;
};
